import LocalEvaluateRequest from "../../../../../mode/local/LocalEvaluateRequest"
import WorkspaceConfig from "../../../../../../workspace/config/WorkspaceConfig"
import { HackleUser, InAppMessageConfig, InAppMessagePlatformType } from "../../../../../../model/model"
import { InAppMessageEvaluateScope } from "../../../InAppMessageEvaluateScope"
import { InAppMessageEligibilityEvaluateRequest } from "../../InAppMessageEligibilityEvaluateRequest"

export class InAppMessageEligibilityLocalEvaluateRequest
  implements LocalEvaluateRequest, InAppMessageEligibilityEvaluateRequest
{
  readonly record = true

  constructor(
    readonly workspace: WorkspaceConfig,
    readonly user: HackleUser,
    readonly entity: InAppMessageConfig,
    readonly scope: InAppMessageEvaluateScope,
    readonly platformType: InAppMessagePlatformType,
    readonly timestamp: number
  ) {}

  get inAppMessage(): InAppMessageConfig {
    return this.entity
  }

  toString(): string {
    return `InAppMessageEligibilityLocalEvaluateRequest(key=${this.inAppMessage.key})`
  }
}
